<div #content>
  <div>
    <div *ngFor="let b of blankBarcodes" class="barcode-container">
      <media-signature
        [media]="null"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
      ></media-signature>
    </div>
    <div *ngFor="let m of Medias" class="barcode-container">
      <media-signature
        [media]="m"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
        [style.background-color]="
          signatureColorRectangle ? null : m.mediaClass.color
        "
      ></media-signature>
    </div>
  </div>
</div>
